import DeleteResourceInteractor from "../../core/interactor/app/crud/DeleteResourceInteractor";
import Constants from "../common/Constants";
import { IIndexType } from "../model/IndexType";

export default class DeleteIndexTypeInteractor {
  private deleteResource: DeleteResourceInteractor;

  constructor({ deleteResource }: any) {
    this.deleteResource = deleteResource;
  }

  async execute(model: IIndexType) {
    return this.deleteResource.execute(Constants.indexGroupBasePath, model.id);
  }
}
